/**
 * Presentation-only projection of the canonical iyzico activation facts
 * (`GET /api/clinic/iyzico/activation-status`) onto the states the Provider
 * UI shows. No status is invented or persisted here, and local KYC
 * completeness is never presented as PSP approval: "active" requires the
 * provider's own confirmation (`can_accept_payments`).
 */
export const deriveActivationState = (snap) => {
  if (!snap) return 'unavailable';
  const acc = snap.psp_account;
  if (!acc) return snap.treatx_facts_ready ? 'ready_to_submit' : 'information_incomplete';
  const status = String(acc.status || '').toLowerCase();
  if (status === 'active' && acc.can_accept_payments) return 'active';
  if (['restricted', 'suspended', 'closed'].includes(status)) return 'provider_rejected';
  // O93 — a bound subMerchantKey means registration SUCCEEDED at iyzico.
  // iyzico publishes no per-submerchant approval status, so this is never
  // presented as "iyzico is reviewing your application": it is a completed
  // registration whose charge capability TreatX has not yet reconciled.
  if (acc.submerchant_bound) return 'registered_not_chargeable';
  // Incomplete TreatX-held information outranks a previous provider refusal:
  // there is nothing to resubmit until the missing data is supplied.
  if (snap.treatx_facts_ready === false) return 'information_incomplete';
  const failed = (acc.requirements_outstanding || []).some(
    (r) => String(r).startsWith('provider_response_failed'),
  );
  if (failed) return 'additional_info_required';
  return snap.treatx_facts_ready ? 'ready_to_submit' : 'information_incomplete';
};

export const ACTIVATION_STATES = [
  'information_incomplete',
  'ready_to_submit',
  'registered_not_chargeable',
  'additional_info_required',
  'active',
  'provider_rejected',
  'unavailable',
];
